import { useEffect, useState } from "react";
import filteringProps from "../filtering/containers.json";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import { toastSuccess } from "../../../components/base/Toast";
import WarehouseContainersFormModal from "../components/WarehouseContainersFormModal";
import WarehouseContainerModel, { WarehouseContainerStatus } from "../models/WarehouseContainerModel";

export default function WarehouseContainersListView() {

  const hub = useHub()

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)

  const [selectedItem, selectedItemSet] = useState<WarehouseContainerModel>()



  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: any) => {
    selectedItemSet(data);
    editModalSet(true);
  }

  const deleteContainer = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: WarehouseContainerModel) => (
    <div>
      <div className="mb-1">
        <a href="#" onClick={e => {
          e.preventDefault()
          edit(data)
        }}>
          {data.name}
        </a>
      </div>
      <div className="text-gray-700 fw-bold fs-8">
        {data.containerID}
      </div>
    </div>
  )

  const StatusItem = (data: WarehouseContainerModel) => (
    <>
      {
        data.operatinalStatus == WarehouseContainerStatus.Active &&
        <FlexRow>
          <Icon icon="circle" type="solid" className="text-success me-1" size={10} />
          <span className="fs-7">Active</span>
        </FlexRow>
      }

      {
        data.operatinalStatus == WarehouseContainerStatus.Inactive &&
        <FlexRow>
          <Icon icon="circle" type="solid" className="text-danger me-1" size={10} />
          <span className="fs-7">Inactive</span>
        </FlexRow>
      }

      {
        data.operatinalStatus == WarehouseContainerStatus.UnderMaintenance &&
        <FlexRow>
          <Icon icon="circle" type="solid" className="text-warning me-1" size={10} />
          <span className="fs-7">Under Maintenance</span>
        </FlexRow>
      }
    </>
  )

  const ContainerTypeItem = (data: WarehouseContainerModel) => (
    <div className="fs-7">
      {data.containerTypeText}
    </div>
  )

  const AddressItem = (data: WarehouseContainerModel) => (
    <>
      {
        data.address ?
          <div className="fs-7">
            {data.address?.title}
          </div>
          :
          <div className="fs-7 text-muted">
            [No Address]
          </div>
      }
    </>
  )

  const ManagerItem = (data: WarehouseContainerModel) => (
    <div>
      {
        data.managerName ?
          <div className="fs-7">
            {data.managerName}
          </div>
          :
          <div className="fs-7 text-muted">
            [No Name]
          </div>
      }
      {
        data.managerPhone &&
        <FlexRow>
          <Icon icon="phone-rotary" type="solid" className="text-gray-700 me-1" size={10} />
          <span className="text-gray-700 fs-8">
            {data.managerPhone?.phoneFriendly}
          </span>
        </FlexRow>
      }

    </div>
  )

  const CreatedItem = (data: WarehouseContainerModel) => (
    <div>
      <div className='d-flex align-items-center fs-7'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const ModifiedItem = (data: WarehouseContainerModel) => (
    <div>
      <div className='d-flex align-items-center fs-7'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {

    validateRole("ManageWarehouseContainers");
    setPage("Warehouse Containers", "Inventory", "Inventory");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Container"
          filteringProps={filteringProps}
          apiRoute={API_ROUTES.InventoryWarehouseContainers}
          addCustom={() => createModalSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteWarehouseContainers")} deleteCustom={deleteContainer}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="Type">
            <ContainerTypeItem />
          </DataTableField>

          <DataTableField title="Status">
            <StatusItem />
          </DataTableField>

          <DataTableField title="Address">
            <AddressItem />
          </DataTableField>

          <DataTableField title="Manager">
            <ManagerItem />
          </DataTableField>

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>



      {
        createModal &&
        <WarehouseContainersFormModal
          onClose={() => {
            createModalSet(false)
            selectedItemSet(undefined)
          }}
          onSave={() => {
            refreshSet(true)
            toastSuccess("Container has been added successfully!")
          }}
        />
      }


      {
        editModal && selectedItem &&
        <WarehouseContainersFormModal
          model={selectedItem}
          onClose={() => {
            createModalSet(false)
            selectedItemSet(undefined)
          }}
          onSave={() => {
            refreshSet(true)
            toastSuccess("Container has been added successfully!")
          }}
        />
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-container"
          title="Delete Container"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onClose={() => {
            deleteModalSet(false)
            selectedItemSet(undefined)
          }}
          onSubmit={(body, callback) => {

            hub.Post(API_ROUTES.InventoryWarehouseContainers + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Container has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          }}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the container?
            </div>
            <div className="alert alert-danger">
              {selectedItem.name}
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
